import { render, staticRenderFns } from "./buttonImportExpert.vue?vue&type=template&id=5bd504b4&scoped=true&"
import script from "./buttonImportExpert.vue?vue&type=script&lang=js&"
export * from "./buttonImportExpert.vue?vue&type=script&lang=js&"
import style0 from "./buttonImportExpert.vue?vue&type=style&index=0&id=5bd504b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd504b4",
  null
  
)

export default component.exports